import { Utils } from 'common';
import React from 'react';
import { DataDisplayPanel } from './DataDisplayPanel.component';

const { Util } = Utils;

const GlobalAdvantageProgramCoverage = ({ labelDetails }) => {
	const { gapClaimEligibility, gapClaimMaxAmount } = labelDetails;

	return (
		<div className="global-advantage-program">
			<DataDisplayPanel
				label="Status:"
				dataqa="gap-coverage"
				body={
					<a
						className="data-display-body details-link"
						href={
							gapClaimEligibility
								? 'https://goglobalpost.custhelp.com/app/answers/detail/a_id/4276/'
								: 'https://goglobalpost.custhelp.com/app/answers/detail/a_id/4081/'
						}
						target="_blank"
						rel="noopener noreferrer"
						data-qa="eligibility-link"
						{...{ dataqa: 'eligibility-link' }}
					>
						{gapClaimEligibility ? 'Eligible' : 'Ineligible'}
					</a>
				}
			/>
			<DataDisplayPanel
				label="Max Claim Amount:"
				body={Util.formatCurrency(gapClaimMaxAmount)}
				dataqa="max-claim-amount"
				bodyClassName="body-amount"
			/>
		</div>
	);
};

export default GlobalAdvantageProgramCoverage;
